<div [style]="style">
  <canvas role="img" (click)="onCanvasClick($event)"></canvas>
</div>
